var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyncBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1385_2646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0959 3.55731V0.94873L7.61776 4.42684L11.0959 7.90495V5.29637C13.974 5.29637 16.313 7.6354 16.313 10.5135C16.313 11.3918 16.0957 12.2265 15.7044 12.9482L16.9739 14.2177C17.6521 13.1482 18.0521 11.8787 18.0521 10.5135C18.0521 6.67022 14.9392 3.55731 11.0959 3.55731ZM11.0959 15.7307C8.21773 15.7307 5.8787 13.3917 5.8787 10.5135C5.8787 9.63531 6.09609 8.80057 6.48737 8.07886L5.21786 6.80935C4.53963 7.87887 4.13965 9.14838 4.13965 10.5135C4.13965 14.3568 7.25256 17.4698 11.0959 17.4698V20.0783L14.574 16.6002L11.0959 13.1221V15.7307Z",
    fill: "#171A21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1385_2646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8687,
    height: 20.8687,
    fill: "white",
    transform: "translate(0.661621 0.0792236)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncBlack);
export default __webpack_public_path__ + "static/media/sync_black.707754e9915a1c249254e7aeb25fe90e.svg";
export { ForwardRef as ReactComponent };